import React from 'react';

const IngredientList = (props) => {
	return (
		<li>{props.ingredient}</li>
	)
}

export default IngredientList;


// WEBPACK FOOTER //
// ./src/components/ingredient_list.js